import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconSlash = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke="none"
        strokeWidth={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.76223 7.3485C9.67997 6.70854 10.796 6.33325 11.9997 6.33325C15.1293 6.33325 17.6663 8.87031 17.6663 11.9999C17.6663 13.2036 17.291 14.3196 16.6511 15.2374L8.76223 7.3485ZM7.34806 8.76276C6.70822 9.68045 6.33301 10.7964 6.33301 11.9999C6.33301 15.1295 8.87006 17.6666 11.9997 17.6666C13.2032 17.6666 14.3191 17.2914 15.2368 16.6515L7.34806 8.76276ZM11.9997 4.33325C7.76549 4.33325 4.33301 7.76574 4.33301 11.9999C4.33301 16.2341 7.76549 19.6666 11.9997 19.6666C16.2339 19.6666 19.6663 16.2341 19.6663 11.9999C19.6663 7.76574 16.2339 4.33325 11.9997 4.33325Z"
        />
      </svg>
    );
  }
);
